import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import './index.scss'

const fmt = (d) => new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

const injectChips = (s) => s.replace(/--((?:[^-\n]|-(?!-))+)--/g, (_, t) => `\`__chip__${t.trim()}\``)

const Post = () => {
  const { slug } = useParams()
  const [content, setContent] = useState('')
  const [meta, setMeta] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    fetch(`/posts/${slug}.md`)
      .then((r) => { if (!r.ok) throw new Error(); return r.text() })
      .then((raw) => {
        const fmMatch = raw.match(/^---\n([\s\S]*?)\n---\n([\s\S]*)$/)
        if (fmMatch) {
          const fm = {}
          fmMatch[1].split('\n').forEach((line) => {
            const [k, ...v] = line.split(':')
            if (k) fm[k.trim()] = v.join(':').trim().replace(/^["']|["']$/g, '')
          })
          const tagsMatch = fmMatch[1].match(/tags:\s*\[([^\]]*)\]/)
          fm.tags = tagsMatch
            ? tagsMatch[1].split(',').map(t => t.trim().replace(/^["']|["']$/g, '')).filter(Boolean)
            : []
          setMeta(fm)
          setContent(injectChips(fmMatch[2]))
        } else {
          setContent(injectChips(raw))
        }
      })
      .catch(() => setError(true))
  }, [slug])

  if (error) return (
    <div className='po-root'>
      <div className='po-inner'>
        <Link to='/blog' className='po-back'>← Back to blog</Link>
        <p className='po-error'>Post not found.</p>
      </div>
    </div>
  )

  return (
    <div className='po-root'>
      <div className='po-inner'>
        <Link to='/blog' className='po-back'>← Back to blog</Link>

        {meta && (
          <header className='po-header'>
            {meta.tags?.length > 0 && (
              <div className='po-tags'>
                {meta.tags.map((t) => <span key={t} className='po-tag'>{t}</span>)}
              </div>
            )}
            <h1 className='po-title'>{meta.title}</h1>
            {meta.date && <div className='po-date'>{fmt(meta.date)}</div>}
          </header>
        )}

        <div className='po-body'>
          <ReactMarkdown breaks components={{
            img: ({ src, alt, title }) => {
              const media = /\.mp4$/i.test(src)
                ? <video src={src} autoPlay muted loop playsInline className='po-media' />
                : <img src={src} alt={alt} className='po-media' />
              return title
                ? <figure className='po-figure'>{media}<figcaption className='po-caption'>{title}</figcaption></figure>
                : media
            },
            code: ({ children, className }) => {
              const text = String(children)
              if (text.startsWith('__chip__')) {
                return <span className='po-type-chip'>{text.slice(8).toUpperCase()}</span>
              }
              return <code className={className}>{children}</code>
            }
          }}>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  )
}

export default Post
